import { RouteConfig } from "vue-router";
import BaseComponent  from "./base.vue";
import { DASHBOARD_ROUTES } from "@/views/dashboard/routes";
//import { DASHBOARD2_ROUTES } from "@/views/dashboard2/routes";
import { UNAUTHORIZE_ROUTES } from "@/views/unauthorize/routes";
import { RESEARCH_ROUTES } from "@/views/research/routes";
import { SUMMARY_ROUTES } from "@/views/summary/routes";

export const BASE_ROUTES: RouteConfig[] = [
  {
    path: "",
    name: "base",
    component: BaseComponent,
    children: [
      ...DASHBOARD_ROUTES,
     // ...DASHBOARD2_ROUTES,
      ...UNAUTHORIZE_ROUTES,
      ...RESEARCH_ROUTES,
      ...SUMMARY_ROUTES
    ]
  }
];